import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'
import TipPoolType from 'src/models/tip/TipPoolType'
import TipShareRule from 'src/models/tip/TipShareRule'

export default class TipPoolShare extends Model {
  static name = 'TipPoolShare'

  static level = MODEL_LEVEL.SITE

  static deletable = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Tipping]

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID
      },
      tipPoolType: {
        type: TipPoolType,
        default: null,
        output: true
      },
      tipPoolTypeId: {
        type: ID,
        default: null
      },
      tipShareRule: {
        type: TipShareRule,
        default: null,
        encode: encoders.hasOne,
        output: true
      },
      sharePercentageThousandths: {
        type: Number,
        default: 10000 // 10%
      }
    }
  }
}
